import { VisuallyHidden } from "@components/Accessibility/VisuallyHidden/VisuallyHidden";
import { ComponentProps } from "@ts/components";
import { clsx } from "clsx";
import React from "react";

export type FormLabelProps = ComponentProps & {
  className?: string;
  field?: string;
  id: string;
  label: string;
  optional?: boolean;
  required: boolean;
  requiredError?: boolean;
};

const Label = (props: any) => (
  <label
    {...props}
    className={clsx(
      props.className,
      "pb-mini",
      props.requiredError && "text-warning",
      props.field === "checkbox" && "pb-zero pl-mini",
    )}
  />
);
const LabelWrapper = (props: any) => (
  <div {...props} className={clsx(props.className, "flex")} />
);
const Required = (props: any) => (
  <div {...props} className={clsx(props.className, "pl-micro text-warning")} />
);
const Optional = (props: any) => (
  <div {...props} className={clsx(props.className, "pl-micro")} />
);

const FormLabel = ({
  className,
  field,
  id,
  label,
  optional,
  required,
  requiredError,
}: FormLabelProps) => {
  return (
    <div className={className}>
      {label && !required && !optional && (
        <LabelWrapper>
          <Label field={field} htmlFor={id}>
            {label}
          </Label>
        </LabelWrapper>
      )}
      {label && required && (
        <LabelWrapper>
          <Label field={field} htmlFor={id} requiredError={requiredError}>
            {label}
          </Label>
          <Required aria-hidden="true">*</Required>
          <VisuallyHidden>required</VisuallyHidden>
        </LabelWrapper>
      )}
      {label && optional && (
        <LabelWrapper>
          <Label field={field} htmlFor={id}>
            {label}
          </Label>
          <Optional>(Optional)</Optional>
        </LabelWrapper>
      )}
    </div>
  );
};
export default FormLabel;
